import { FC, useContext } from "react";

import CaseDraftItem from "./draftItem";

import { CaseContext } from "src/context/caseContext";

import { CaseDraft, PendingSubmissionsProps } from "./types";
import { AddCaseProps } from "src/pages/addCase/types";




const PendingSubmissions: FC<PendingSubmissionsProps> = ({ reset }): JSX.Element => {
  const { caseDraftListing, getCaseDraftListing } = useContext(CaseContext)


  const populateCaseDraftInForm = (chosenDraft: CaseDraft) => {
    if (caseDraftListing && caseDraftListing.result && caseDraftListing.result.length > 0) {
      const selectedDraft = caseDraftListing.result.find((draft: CaseDraft) => draft.id === chosenDraft.id)

      if (selectedDraft) {
        const { draft_json } = selectedDraft;
        const jsonFields = JSON.parse(draft_json) as Partial<AddCaseProps>;
        reset(jsonFields)
      }
    }
  }


  return (
    <div className="d-flex flex-column sticky-top pending-card">
      <div className="card shadow flex-fill">
        <div className={"card-header sticky-top z-1 d-flex align-items-center justify-content-between"}>
          <h1 className="m-0">Pending</h1>
          <div className="pending-tooltip">
            <button type="button" className="btn text-warning p-0">
              <i className="bi bi-info-circle-fill fs-5"></i>
            </button>
            <div className="tooltip fade">
              <i className="arrow bi bi-caret-down-fill"></i>
              <div className="tooltip-inner">List of prescriptions not yet submitted</div>
            </div>
          </div>
        </div>
        <div className="card-body p-0 d-flex flex-column overflow-hidden" style={{flex: '1 1 0'}}>
          {caseDraftListing && caseDraftListing.result && caseDraftListing.result.length > 0 ? (
            <ul className={"list-group list-group-flush pending-submission-list"}>
              {caseDraftListing.result.map((draft: CaseDraft) => (
                <CaseDraftItem
                  key={draft.id} draft={draft}
                  getCaseDraftListing={getCaseDraftListing}
                  populateCaseDraftInForm={populateCaseDraftInForm}
                  reset={reset}
                />
              ))}
            </ul>
            ) : (
              <p className="d-flex flex-column alert alert-warning text-center m-3 small">
              <i className="bi bi-info-circle-fill fs-5"></i> No Pending Submissions
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default PendingSubmissions
